import styled from 'styled-components';
import { ProductData } from '../../types';

const StyledProduct = styled.div<{ numberOfProducts: number }>`
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    margin-right: ${(props: any) => `${1.4 - 0.2 * props.numberOfProducts}em`};
    &:last-child {
        margin-right: 0;
    }

    img {
        width: 60px;
        object-fit: contain;
        margin-bottom: 4px;
    }
    @media (max-width: 400px) {
        img {
            width: 45px;
        }
    }
`;

const StyledProductText = styled.span`
    font-size: 22px;
    color: ${(props: any) => props.color};
    font-weight: bold;
    text-shadow: 1px 1px 3px #693510, -1px -1px 3px #693510,
        1px -1px 3px #693510, -1px 1px 3px #693510;

    img {
        height: 20px;
        width: 20px;
    }

    @media (max-width: 376px) {
        font-size: 14px;
    }
`;

function BundleProduct({
    images,
    textFontColorHex,
    quantityDisplay,
    numberOfProducts = 0
}: ProductData) {
    return (
        <StyledProduct numberOfProducts={numberOfProducts}>
            <img src={images.product} alt="product" />
            <StyledProductText color={textFontColorHex}>
                {images.productPrefix && (
                    <img src={images.productPrefix} alt="prefix" />
                )}
                {quantityDisplay}
            </StyledProductText>
        </StyledProduct>
    );
}

export default BundleProduct;
